Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.DateFilterView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/date/date_filter"]
  className: 'filter time collapsed'

  events:
    'click #apply-date': '_addDate'
    'click .now-check-box': '_onNowChange'
    'change #now': '_onNowChange'
    'click #from': 'selectingFrom'
    'click #to': 'selectingTo'
    'click #from_time': 'validateTime'
    'click #to_time': 'validateTime'
    'click .customRadio': 'checkRadioButton'
    'click .now-check-label': 'onNowLabelClick'
    'onfocus #to_time': 'hideSelectors'
    'onfocus #from_time': 'hideSelectors'

  fields:
    date_from_realtime: 'date_from_realtime'
    date_from: 'date_from'
    date_from_ISO: 'date_from_ISO'
    date_to: 'date_to'
    date_to_ISO: 'date_to_ISO'
    date_now: 'date_now'

  initialize: ({searchQuery, facet, filtersContainer, allowAllHistory}) ->
    @searchQuery = searchQuery
    @facet = facet
    @title = I18n.t('monitoring.dashboard.filters.filter_names.time.name')
    @filtersContainer = filtersContainer
    # Custom-attribute date filters keep the unbounded "All history" option and
    # no 3-year floor; built-in content/ticket date filters leave this unset.
    @allowAllHistory = allowAllHistory
  destroy: ->
    this.remove()
    return false

  render: ->
    @$el.html(@template(currentDate: @currentDate(), viewId: @cid, title: @title, allowAllHistory: @allowAllHistory))
    @_renderDatePicker()
    @disableCalendarIconEvents()
    @$el.find('.radio').on('click', @_handleRadioButtons)
    if @searchQuery.get(@fields['date_from_realtime'])
      realtimeValue = @searchQuery.get(@fields['date_from_realtime']).value
      realtimeValue = '1576800' if realtimeValue == 'all_history' and not @allowAllHistory # legacy sessions: select "Last three years"
      @$el.find("#realtime_cbo option[value=#{realtimeValue}]").prop('selected', true)
    else if @searchQuery.hasEspecificTime(@prefix())
      @$el.find('.timerange').get(0).checked = true
      @$el.find('.realtime').get(0).checked = false
      @$el.find('.datepicker.from').datepicker().data('datepicker').setDate(Date.create(@searchQuery.get(@fields['date_from_ISO'])))
      @$el.find("#from_time option[value=\"#{Date.create(@searchQuery.get(@fields['date_from_ISO'])).format('HH:mm')}\"]").prop('selected', true)
      if @searchQuery.get(@fields['date_now'])
        @enableNowCheck()
        @_onNowChangeManual()
      else
        @$el.find('.datepicker.to').datepicker().data('datepicker').setDate(new Date(@searchQuery.get(@fields['date_to_ISO'])))
        @$el.find("#to_time option[value=\"#{new Date(@searchQuery.get(@fields['date_to_ISO'])).format('HH:mm')}\"]").prop('selected', true)

    @_handleRadioButtons()
    return this

  _renderDatePicker: () ->
    minDate = @_minDate()

    datepickerOptions =
      container: @filtersContainer
      todayBtn: 'linked'
      autoclose: true
      format: 'dd/mm/yyyy'
    # Existing sessions whose stored dates predate the window keep them:
    # the lower-bound restriction is skipped so the old dates render and stay valid.
    datepickerOptions.startDate = minDate unless @allowAllHistory or @_hasDatesBefore(minDate)
    @$el.find('.datepicker').datepicker(datepickerOptions)

    today = new Date()
    tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)

    @$el.find('.datepicker.from').datepicker('update', today.format('DD-MM-YYYY'))
    @$el.find('.datepicker.to').datepicker('update',  tomorrow.format('DD-MM-YYYY'))
    datePickerFrom = @$el.find('.datepicker.from').datepicker().data('datepicker')
    datePickerTo = @$el.find('.datepicker.to').datepicker().data('datepicker')

    @$el.find('.datepicker.from').on('changeDate', (ev) =>
      newDate = new Date(ev.date)
      if newDate && datePickerTo.getDate() < newDate
        @$el.find('.datepicker.to').datepicker('update', newDate)
        @validateTime()
    )
    @$el.find('.datepicker.to').on('changeDate', (ev) =>
      newDate = new Date(ev.date)
      if newDate && datePickerFrom.getDate() > newDate
        @$el.find('.datepicker.from').datepicker('update', newDate)
        @validateTime()
    )

  # Lower bound for the datepicker. Built-in content/ticket filters cap it to
  # the last 3 years; subclasses may widen it.
  _minDate: ->
    @_threeYearsAgo()

  _threeYearsAgo: ->
    date = new Date()
    date.setFullYear(date.getFullYear() - 3)
    date

  # Survey date filters reach back to the start of available data (Jan 2020)
  # when the account has old content enabled, instead of the 3-year window.
  _oldContentAwareMinDate: ->
    if Keepcon.applicationSettings?.monitoring?.old_content_enabled
      new Date(2020, 0, 1)
    else
      @_threeYearsAgo()

  _hasDatesBefore: (cutoff) ->
    for suffix in ['from_ISO', 'to_ISO']
      value = @searchQuery.get("#{@prefix()}_#{suffix}")
      return true if value and new Date(value) < cutoff
    false

  _handleRadioButtons: =>
    specificTimeDiv = @$el.find('.specific-time')
    realtimeDiv = @$el.find('.real-time')
    if @$el.find('.realtime').get(0).checked == true
      realtimeDiv.find('#realtime_cbo').removeAttr('disabled')
      specificTimeDiv.find('input,select').each(
        (index, element) =>
          if (element.type != "radio")
            $(element).attr('disabled', true)
      )
      specificTimeDiv.find('.calendar').off('click')
      @disableCalendarIcons()
      @disableNowCheck()
      @toggleRadioButtons(realtimeDiv, specificTimeDiv)
    else
      realtimeDiv.find('#realtime_cbo').attr('disabled', true)
      @$el.find('#from').removeAttr('disabled')
      @$el.find('#from_time').removeAttr('disabled')
      @enableNowCheck()
      @enableElement(@$el.find('.from').find('.floating-add-on'))
      @enableElement(@$el.find('.from').find('label'))
      unless @isNowChecked()
        @$el.find('#to').removeAttr('disabled')
        @$el.find('#to_time').removeAttr('disabled')
        @enableElement(@$el.find('.to').find('.floating-add-on'))
        @enableElement(@$el.find('.to').find('label'))
      @$el.find('.calendar').on('click', @_onClickCalendar)
      @toggleRadioButtons(specificTimeDiv, realtimeDiv)

  prefix: ->
    'date'

  _addDate: =>
    dateFrom =  ""
    realtime = @$el.find('.realtime').get(0).checked
    now = true

    # Reset date filters
    @searchQuery.removeDateTo(@prefix())
    @searchQuery.removeDateFrom(@prefix())
    @searchQuery.setNowDate(false, @prefix())
    @searchQuery.removeDateFromRealtime(@prefix())

    if realtime
      select = @$el.find('#realtime_cbo')
      @searchQuery.addDateFromRealtime(
        select.val(),
        select.find('option:selected').text(),
        @prefix()
      )
    else
      dateFrom = @$el.find('#from').val() + ' ' + @$el.find('#from_time').val()
      dateTo = @$el.find('#to').val() + ' ' + @$el.find('#to_time').val()
      now = @isNowChecked()
      @searchQuery.addDateTo(Date.create(dateTo, 'DD/MM/YYYY HH:mm ZZ'), 'DD/MM/YYYY HH:mm', @prefix()) unless now
      @searchQuery.addDateFrom(Date.create(dateFrom, 'DD/MM/YYYY HH:mm ZZ'), 'DD/MM/YYYY HH:mm', @prefix())
      @searchQuery.setNowDate(now, @prefix())
    @_triggerQueryChanged()

  _triggerQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  _onNowChange: (event) =>
    nowCheckElement = $(event.currentTarget)
    @hideSelectors(nowCheckElement)
    @toggleToDatePickerState()

  _onNowChangeManual: () =>
    @hideSelectors(@$el)
    @toggleToDatePickerState()

  onNowLabelClick: (event) =>
    labelElement = $(event.currentTarget)
    unless @isDisabled(labelElement)
      nowCheckElement = $(labelElement).parent()
      @hideSelectors(nowCheckElement)
      @toggleToDatePickerState()

  selectingFrom: =>
    @$el.find('.to').datepicker("hide")

  selectingTo: =>
    @$el.find('.from').datepicker("hide")

  currentDate: =>
    date = Date()
    currentDate = date.substr(8,2) + ' ' + date.substr(4,3) + ' ' + date.substr(13,2)

  validateTime: =>
    fromTime = @$el.find('#from_time').val()
    toTime = @$el.find('#to_time').val()
    if (@$el.find('#from').val() == @$el.find('#to').val()) && (fromTime > toTime)
      @$el.find('#to_time').val(fromTime)

  isEmpty: ->
    false

  isNowChecked: ->
    @isHidden(@$el.find('.now-check-box').find('#now-check-unselected'))

  enableNowCheck: ->
    @showElement(@$el.find('.now-check-box'))
    @hideElement(@$el.find('.disabled-now-check'))
    @enableElement(@$el.find('.nowCheck').find('label'))

  disableNowCheck: ->
    @showElement(@$el.find('.disabled-now-check'))
    @hideElement(@$el.find('.now-check-box'))
    @disableElement(@$el.find('.nowCheck').find('label'))
    @uncheckNowSelector()

  checkRadioButton: (event) ->
    $(event.currentTarget).children().prop( "checked", true )

  toggleRadioButtons: (checkedDiv, uncheckedDiv) ->
    $(checkedDiv).find('.customRadio').children().prop("checked", true)
    $(uncheckedDiv).find('.customRadio').children().prop("checked", false)

  hideSelectors: (element) ->
    $(element).closest(".specific-time").find(".to").datepicker("hide")
    $(element).closest(".specific-time").find(".from").datepicker("hide")
    selected = @isNowChecked()
    if selected
      @uncheckNowSelector()
    else
      @checkNowSelector()

  checkNowSelector: ->
    element = @$el.find(".nowCheck")
    @hideElement($(element).find("#now-check-unselected"))
    @showElement($(element).find("#now-check-selected"))
    $(element).find(".now-check-label").addClass("selected")

  uncheckNowSelector: ->
    element = @$el.find(".nowCheck")
    @hideElement($(element).find("#now-check-selected"))
    @showElement($(element).find("#now-check-unselected"))
    $(element).find(".now-check-label").removeClass("selected")

  toggleToDatePickerState: ->
    now = @isNowChecked()
    @$el.find('#to').attr('disabled', now)
    @$el.find('#to_time').attr('disabled', now)
    if now
      @disableElement(@$el.find('.to').find('.floating-add-on'))
      @disableElement(@$el.find('.to').find('label'))
    else
      @enableElement(@$el.find('.to').find('.floating-add-on'))
      @enableElement(@$el.find('.to').find('label'))

  disableCalendarIconEvents: ->
    @$el.find(".floating-add-on").off()

  disableCalendarIcons: ->
    @disableElement(@$el.find('.from').find('.floating-add-on'))
    @disableElement(@$el.find('.from').find('label'))
    @disableElement(@$el.find('.to').find('.floating-add-on'))
    @disableElement(@$el.find('.to').find('label'))

  hideElement: (element) ->
    element.addClass('d-none')

  showElement: (element) ->
    element.removeClass('d-none')

  isHidden: (element) ->
    element.hasClass("d-none")

  enableElement: (element) ->
    element.removeClass('disabled')

  disableElement: (element) ->
    element.addClass('disabled')

  isDisabled: (element) ->
    element.hasClass('disabled')
